module.exports = __webpack_public_path__ + "img/sm-instagram.b406c10f.svg";